$(document).ready(function () {

    $(".cv-review").click(function () {
        $("li.review_tab a").trigger("click");
    });
    var a = $("#countpagination").find("span").length - 1;
    $(window).scroll(function () {
        var d = $("#AjaxinatePagination").text();
        var c = "";
        $(".whenproductsaresold").each(function () {
            c += $(this).html();
        });
        $(".whenproductsaresold").remove();
        $("#AjaxinateContainersoldoutproduct").append(c);
        if (!$.trim($("#AjaxinatePagination").html()).length) {
            var e = $("#itsdone").val();
            if (e === "done") {
                var b = $("#AjaxinateContainersoldoutproduct").html();
                $("#AjaxinateContainer").append(b);
                $("#itsdone").val("0");
                $("#AjaxinateContainersoldoutproduct").html(" ");
            }
        }
    });

  $('body').on('click','.description_wrapper .readmore', function (event) {
    
    event.preventDefault();
    if($(this).hasClass('active')){
      console.log('elsss')
      $(this).closest('.description_wrapper').find('.collection__description').removeClass('active');
      $(this).removeClass('active').text('Show More');
    }else{
      console.log('iffff')
      $(this).closest('.description_wrapper').find('.collection__description').addClass('active');
      $(this).addClass('active').text('Show Less');
    }
    // var descriptionFull = document.querySelector('.collection__description .product-description-full');
    // descriptionFull.style.display = 'block';
    // var descriptionShort = document.querySelector('.collection__description .product-description-short');
    // descriptionShort.style.display = 'none';
  });
  // $('.collection__description .readless').click(function (event) {
  //   event.preventDefault();
  //   var descriptionFull = document.querySelector('.collection__description .product-description-full');
  //   descriptionFull.style.display = 'none';
  //   var descriptionShort = document.querySelector('.collection__description .product-description-short');
  //   descriptionShort.style.display = 'block';
  //   // window.scrollTo({top: 110, behavior: 'smooth'});
  // })

  $(document).on('click', '.custom-share-btn', async function () {
    var title = $('body').attr('data-article-title');
    if($(this).closest('blockquote').length > 0){
        const $clone = $(this).closest('blockquote').clone();     // Clone the element
        $clone.find('button').remove();          // Remove buttons
        $clone.find('script, style').remove();   // Safety

        
        const cleanText = $clone.text().trim();
        const formattedText = `${cleanText}\n\n${title}\n\n${window.location.href}`;
        const shareData = {
          text: formattedText
        };

        try {
          if (navigator.share) {
            await navigator.share(shareData);
          } else {
            alert("Sharing not supported on this device");
          }
        } catch (err) {
          console.log("Share cancelled", err);
        }
    }else if($(this).closest('.img-relative-wrapper').length > 0){
      const imageUrl = $(this).closest('.img-relative-wrapper').find('img').attr('src');

      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const file = new File([blob], "article.jpg", { type: blob.type });
      const formattedText = `${title}\n\n${window.location.href}`;
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          text: formattedText,
          files: [file],
        });
      } else {
        alert("Image sharing not supported");
      }
    }else if($(this).closest('.article__image-wrapper').length > 0){
      const imageUrl = $(this).closest('.article__image-wrapper').find('img').attr('src');

      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const file = new File([blob], "article.jpg", { type: blob.type });
      const formattedText = `${title}\n\n${window.location.href}`;
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          text: formattedText,
          files: [file],
        });
      } else {
        alert("Image sharing not supported");
      }
    }
    
    
  });

  $('.article__body .body_content blockquote').each(function () {
    if (!$(this).find('.custom-share-btn').length) {
      $(this).css('position', 'relative');
      $(this).append('<button class="custom-share-btn"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 48 48" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M35.274 15.838H31.18a1.5 1.5 0 1 0 0 3h4.095c.827 0 1.5.673 1.5 1.5v19.616c0 .827-.673 1.5-1.5 1.5H12.726c-.827 0-1.5-.673-1.5-1.5V20.338c0-.827.673-1.5 1.5-1.5h4.095a1.5 1.5 0 1 0 0-3h-4.095a4.505 4.505 0 0 0-4.5 4.5v19.616c0 2.481 2.019 4.5 4.5 4.5h22.549c2.481 0 4.5-2.019 4.5-4.5V20.338a4.506 4.506 0 0 0-4.501-4.5zM18.407 12.81l4.143-4.143v19.748a1.5 1.5 0 1 0 3 0V8.667l4.143 4.143c.293.293.677.439 1.061.439s.768-.146 1.061-.439a1.5 1.5 0 0 0 0-2.121l-6.703-6.704a1.5 1.5 0 0 0-2.122 0l-6.704 6.704a1.5 1.5 0 1 0 2.121 2.121z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg></button>');
    }
  });

  if ($('.article__image-wrapper').length > 0) {
    $('.article__image-wrapper').append('<button class="custom-share-btn"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 48 48" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M35.274 15.838H31.18a1.5 1.5 0 1 0 0 3h4.095c.827 0 1.5.673 1.5 1.5v19.616c0 .827-.673 1.5-1.5 1.5H12.726c-.827 0-1.5-.673-1.5-1.5V20.338c0-.827.673-1.5 1.5-1.5h4.095a1.5 1.5 0 1 0 0-3h-4.095a4.505 4.505 0 0 0-4.5 4.5v19.616c0 2.481 2.019 4.5 4.5 4.5h22.549c2.481 0 4.5-2.019 4.5-4.5V20.338a4.506 4.506 0 0 0-4.501-4.5zM18.407 12.81l4.143-4.143v19.748a1.5 1.5 0 1 0 3 0V8.667l4.143 4.143c.293.293.677.439 1.061.439s.768-.146 1.061-.439a1.5 1.5 0 0 0 0-2.121l-6.703-6.704a1.5 1.5 0 0 0-2.122 0l-6.704 6.704a1.5 1.5 0 1 0 2.121 2.121z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg></button>');
  }
  // 2. Add button to every <a> that contains an <img>
  $('.article__body .body_content img').each(function () {
    if (!$(this).parent().hasClass('img-relative-wrapper')) {
      $(this).wrap('<div class="img-relative-wrapper" style="position: relative;"></div>');
    }
    $(this).after('<button class="custom-share-btn"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 48 48" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M35.274 15.838H31.18a1.5 1.5 0 1 0 0 3h4.095c.827 0 1.5.673 1.5 1.5v19.616c0 .827-.673 1.5-1.5 1.5H12.726c-.827 0-1.5-.673-1.5-1.5V20.338c0-.827.673-1.5 1.5-1.5h4.095a1.5 1.5 0 1 0 0-3h-4.095a4.505 4.505 0 0 0-4.5 4.5v19.616c0 2.481 2.019 4.5 4.5 4.5h22.549c2.481 0 4.5-2.019 4.5-4.5V20.338a4.506 4.506 0 0 0-4.501-4.5zM18.407 12.81l4.143-4.143v19.748a1.5 1.5 0 1 0 3 0V8.667l4.143 4.143c.293.293.677.439 1.061.439s.768-.146 1.061-.439a1.5 1.5 0 0 0 0-2.121l-6.703-6.704a1.5 1.5 0 0 0-2.122 0l-6.704 6.704a1.5 1.5 0 1 0 2.121 2.121z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg></button>');
  });

  if($('#saleendsin').length > 0){
    var endtime = $('#saleendsin').attr('data-expired_date');
    // Set the date we're counting down to
    var countDownDate = new Date(endtime).getTime();
    
    // Update the count down every 1 second
    var x = setInterval(function() {
    
      // Get today's date and time
      var now = new Date().getTime();
        
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
        
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));   
      var dayshtml = '';
      if(days > 0){
        dayshtml = '<span class="value">'+days+'d</span><span>:</span>';
      }
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));      
      if(hours < 10){
        hours = '0'+hours; 
      } 
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if(minutes < 10){
        minutes = '0'+minutes; 
      } 
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if(seconds < 10){
        seconds = '0'+seconds; 
      } 
        
      // Output the result in an element with id="demo"
      document.getElementById("saleendsin").innerHTML = dayshtml+'<span class="value">'+hours+'h</span><span>:</span><span class="value">'+minutes+'m</span><span>:</span><span class="value">'+seconds+'s</span>';
        
      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("timer_wrapper").style.display = "none";
      }
    }, 1000);
  }

  if($('#CollectionAjaxContent .grid__item--sidebar').length > 0){
   $(window).scroll(function() {
    if ($(document).scrollTop() > 250) {
      $("#CollectionAjaxContent .grid__item--sidebar").addClass("test_sidebar");
    } else {
      $("#CollectionAjaxContent .grid__item--sidebar").removeClass("test_sidebar");
    }
  }); 
  } 

  // Clear URL parameters without reloading the page
  function clearURLParameters() {
    // Get the current URL
    const url = new URL(window.location.href);
  
    // Remove all query parameters
    url.search = "";
  
    // Optionally, remove the fragment (everything after #)
    url.hash = "";
  
    // Update the URL without reloading the page
    window.history.replaceState(null, null, url.toString());
  }
  
  var live_url = window.location.href;
  var result = live_url.includes('form_type=customer');
  var resultischal = live_url.includes('/challenge');
  if(result && !resultischal && $('#newsletter-footer').length != 0 && $('#newsletter-footer .errors').length == 0){
      const add_ele = document.createElement("p");
      add_ele.innerText = "You have already subscribed!";
      $('#newsletter-footer').prepend(add_ele);
      add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
      if($(window).width() < 767){
       $('.footer_newsletter_trigger').trigger('click'); 
      }      
      clearURLParameters();
  }
  if(live_url.includes('/challenge')){
    setTimeout(function(){
      window.scrollTo({top: 0, behavior: 'smooth'});
    },2000);    
  }

  if((window.location.href.includes('sort_by') || window.location.href.includes('page')) && $(".main-collection-grid").length > 0){  
    window.scrollTo({top: $(".main-collection-grid").offset().top, behavior: 'smooth'});
  }

  if($('.havetotrigger').length > 0){
    $('.havetotrigger').trigger('click');
  }
  
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  var header = $(".product-single__meta .sticky_atc_wrapper");
  if($('body').hasClass('template-product')){
    
    if ($(".product-single__meta .buybutton_block").isInViewport()) {      
      header.removeClass("is-fixed");
      header.closest('.product-block').removeAttr('style');
    }else{      
       header.addClass("is-fixed");
       header.closest('.product-block').attr('style','padding-top: '+ header.outerHeight() +'px;');
    }
     $(window).scroll(function() {    
      if ($(".product-single__meta .buybutton_block").isInViewport()) {      
        header.removeClass("is-fixed");
        header.closest('.product-block').removeAttr('style');
      }else{      
         header.addClass("is-fixed");
         header.closest('.product-block').attr('style','padding-top: '+ header.outerHeight() +'px;');
      }
     });
  }

  // PRODUCT OFFERS COPY CODE
  $('.product-offer-header').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });
  
  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this);
    var text = $(this).parent().find('.product-offer-code').text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  // PDP Product Tabs  
  $("body").on("click",".btn-tab-pro", function(){
    var btnId = $(this).attr('data-pro');
    if($(this).hasClass('activee')){
      $(this).closest('.pdp-tab-slct-optn-tabs').find('.btn-tab-pro').removeClass('activee')
      $(this).closest('.pdp-tab-slct-optn-wrap').find('.pdp-tab-slct-optn-pro-blck').addClass('hide');
    }else{
      $(this).closest('.pdp-tab-slct-optn-tabs').find('.btn-tab-pro').removeClass('activee')
      $(this).addClass('activee')
      $(this).closest('.pdp-tab-slct-optn-wrap').find('.pdp-tab-slct-optn-pro-blck').addClass('hide');
      $(this).closest('.pdp-tab-slct-optn-wrap').find('[data-list="'+btnId+'"]').removeClass('hide');  
    }
    
  });

  $('.custom-blogs_wrapper').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.logo-bar').slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true
        }
      }
    ]
  });
  $('.mwt-media_col-slider').slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  });

  $('.article .article_related_products .article_flex_slider').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M256 0C114.837 0 0 114.837 0 256s114.837 256 256 256 256-114.837 256-256S397.163 0 256 0zm57.749 347.584c8.341 8.341 8.341 21.824 0 30.165A21.275 21.275 0 0 1 298.666 384a21.277 21.277 0 0 1-15.083-6.251L176.917 271.083c-8.341-8.341-8.341-21.824 0-30.165l106.667-106.667c8.341-8.341 21.824-8.341 30.165 0s8.341 21.824 0 30.165L222.165 256l91.584 91.584z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M256 0C114.837 0 0 114.837 0 256s114.837 256 256 256 256-114.837 256-256S397.163 0 256 0zm79.083 271.083L228.416 377.749A21.275 21.275 0 0 1 213.333 384a21.277 21.277 0 0 1-15.083-6.251c-8.341-8.341-8.341-21.824 0-30.165L289.835 256l-91.584-91.584c-8.341-8.341-8.341-21.824 0-30.165s21.824-8.341 30.165 0l106.667 106.667c8.341 8.341 8.341 21.823 0 30.165z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg></button>'
  });

  $('body').on('change','.article__body .article-nav-section .scroll_selector', function(){
    var selectr = $(this).val();
    console.log(selectr);
    var mm = $(this).closest('.article__body').find('.body_content h2.'+selectr);
    if(mm.length > 0){
     window.scrollTo({top: mm.offset().top - 80, behavior: 'smooth'});
    }    
  });

  $('body').on('click','.article__body .article-nav-section a', function(){
    var selectr = $(this).attr('data-toscroll');
    var mm = $(this).closest('.article__body').find('.body_content h2.'+selectr);
    if(mm.length > 0){
     window.scrollTo({top: mm.offset().top, behavior: 'smooth'});
    }    
  });
  
  if($(window).width() < 740){
    var header = $(".article__body .article-nav-section");
    if (header.length) {
      var offtop = header.offset().top;
      $(window).scroll(function() {    
        if (window.pageYOffset > offtop) {
          header.addClass("fixed");        
        } else {
          header.removeClass("fixed");
        }
      }); 
    }    
  };

  $('body').on('click','.go-top', function (e) {
    e.preventDefault();
    console.log('clickck')
    $('html, body').animate({ scrollTop: 0 }, 600); // 600 = speed in ms
  }); 
  
  if ($(window).scrollTop() > 400) {
    $('.go-top').addClass('showw');
  } else {
    $('.go-top').removeClass('showw');
  }

  if($('.collection-filter').length > 0){
    var filterTop = $('.collection-filter').offset().top;
    
    $(window).on('scroll', function () {
      if ($(window).scrollTop() >= filterTop) {
        $('.collection-filter').addClass('sticky');
      } else {
        $('.collection-filter').removeClass('sticky');
      }
    });
  }

  $('body').on('click','.careers .job_details_toggle', function(e){
    console.log('innnn')
    if ($(e.target).closest('a, button').length) return;
    $(this).find('.tab_content[data-tab="'+$(this).attr('data-tab')+'"]').slideToggle();
  });

  $('body').on('click','.careers .tab_button', function(e){
    e.stopPropagation();
    $(this).closest('.job-item').find('.tab_content').not('[data-tab="'+$(this).attr('data-tab')+'"]').slideUp();
    $(this).closest('.job-item').find('.tab_content[data-tab="'+$(this).attr('data-tab')+'"]').slideToggle();
  });

  $('body').on('click','.careers .form_model_button', function(e){
    $('.form_popup_model,.form_model_overlay').addClass('active');
  });

  $('body').on('click','.form_popup_model .close_buttonwp', function(e){
    $('.form_popup_model,.form_model_overlay').removeClass('active');
  });

});


$(window).on('scroll resize', function () {
  if ($(window).scrollTop() > 400) {
    $('.go-top').addClass('showw');
  } else {
    $('.go-top').removeClass('showw');
  }
});





